import { Controller } from "@hotwired/stimulus";
import {
  beginSkeletonWait,
  endSkeletonWait,
} from "../skeleton_wait_support";
const OPEN_QUESTION_LINK_SELECTOR =
  "a[data-turbo-stream='true'][href*='/school_usage/open_question']";
const WAITING_SAFETY_MS = 90_000;

export default class extends Controller {
  static values = {
    modalFrameId: String,
  };

  connect() {
    this.awaitingOpenQuestion = false;
    this.boundBeforeStreamRender = this.onBeforeStreamRender.bind(this);
    this.boundFetchError = this.onFetchError.bind(this);

    document.addEventListener(
      "turbo:before-stream-render",
      this.boundBeforeStreamRender,
    );
    this.bindModalFrameListener();
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-stream-render",
      this.boundBeforeStreamRender,
    );
    this.unbindModalFrameListener();
    this.endWait();
  }

  modalFrameElement() {
    return document.getElementById(this.modalFrameIdValue);
  }

  bindModalFrameListener() {
    this.unbindModalFrameListener();
    const modalFrame = this.modalFrameElement();
    if (!modalFrame) return;

    modalFrame.addEventListener("turbo:fetch-request-error", this.boundFetchError);
    this.boundModalFrame = modalFrame;
  }

  unbindModalFrameListener() {
    this.boundModalFrame?.removeEventListener(
      "turbo:fetch-request-error",
      this.boundFetchError,
    );
    this.boundModalFrame = null;
  }

  beforeOpenQuestionClick(event) {
    const link = event.target.closest(OPEN_QUESTION_LINK_SELECTOR);
    if (!link || !this.element.contains(link)) return;

    this.awaitingOpenQuestion = true;
    this.bindModalFrameListener();
    this.beginWait();
  }

  onBeforeStreamRender(event) {
    if (!this.awaitingOpenQuestion) return;
    if (event.target.getAttribute("target") !== this.modalFrameIdValue) return;

    this.endWait();
  }

  onFetchError(event) {
    if (!this.awaitingOpenQuestion) return;

    const modalFrame = this.modalFrameElement();
    if (event.target !== modalFrame) return;

    this.endWait();
  }

  beginWait() {
    beginSkeletonWait(this.element);
    this.scheduleSafetyClear();
  }

  endWait() {
    if (!this.awaitingOpenQuestion) return;

    this.awaitingOpenQuestion = false;
    window.clearTimeout(this.safetyTimeout);
    endSkeletonWait(this.element);
  }

  scheduleSafetyClear() {
    window.clearTimeout(this.safetyTimeout);
    this.safetyTimeout = window.setTimeout(() => this.endWait(), WAITING_SAFETY_MS);
  }
}
